import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogCloseComponent } from './dialog-close.component';

@NgModule({
  declarations: [DialogCloseComponent],
  imports: [
    CommonModule
  ],
  exports: [DialogCloseComponent]
})
export class DialogCloseModule { }
